import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MobileTooltipTriggerDirective } from '@shared/directives';
import { TranslateModule } from '@ngx-translate/core';
import { FooterModule } from '@shared/components/footer/footer.module';
import { HeaderModule } from '@shared/components/header/header.module';
import { DefaultImageModule } from '@shared/directives/default-image.module';
import { ImageStoragePipe, ImageStoragePipeModule } from '@shared/pipes/image-storage-pipe';
import { MgtRoutingModule } from './mgt-routing.module';
import { MgtComponent } from './mgt.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
@NgModule({
  declarations: [MgtComponent, SidebarComponent],
  providers: [ImageStoragePipe],
  imports: [
    CommonModule,
    MgtRoutingModule,
    HeaderModule,
    FooterModule,
    TranslateModule,
    FormsModule,
    DefaultImageModule,
    MatSidenavModule,
    MatButtonModule,
    MatIconModule,
    MatMenuModule,
    MatTooltipModule, MobileTooltipTriggerDirective,
    ImageStoragePipeModule,
    MatProgressSpinnerModule,
  ],
})
export class MgtModule {}
